import { noop } from 'lodash'
import React from 'react'

import Checkbox from '../../../Checkbox'
import { TCheckboxValue, TFunctionCallback } from '../../types'

interface CheckboxColumnProps
  extends Omit<React.HTMLProps<HTMLDivElement>, 'value' | 'label'> {
  value: TCheckboxValue
  tooltip: string | null
  onChange: TFunctionCallback
  disabled?: boolean
  label?: React.ReactNode
}
const CheckboxColumn = (props: CheckboxColumnProps): React.ReactElement => {
  const { value, tooltip, onChange = noop, disabled = false, ...rest } = props

  return (
    <div {...rest}>
      <Checkbox
        onChange={onChange}
        value={value}
        disabled={disabled}
        tooltip={tooltip as string}
      />
    </div>
  )
}

export default CheckboxColumn
